export default __webpack_public_path__ + "static/media/blogIndex1.4e8704e1.png";